import Button from '@codegouvfr/react-dsfr/Button';
import React from 'react';
import './fc-paginator.css';

/**
 * Page front (n) = Page back (n - 1)
 */
export const FcPaginator = ({ page, totalPages, onPageChange, ellipsis = 2 }: FcPaginationProps) => {
  const displayedPage = page + 1;

  const buildPages = () => {
    const pages: (number | string)[] = [1];

    const rangeStart = Math.max(2, displayedPage - ellipsis);
    const rangeEnd = Math.min(totalPages - 1, displayedPage + ellipsis);

    if (rangeStart > 2) pages.push('...');

    for (let i = rangeStart; i <= rangeEnd; i++) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }

    if (rangeEnd < totalPages - 1) pages.push('...');
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  return (
    <div className={'fr-paginator no-select'}>
      <Button
        iconId="fr-icon-arrow-left-s-line"
        onClick={() => onPageChange?.(page - 1)}
        priority="tertiary no outline"
        disabled={page === 0 || totalPages === 0}
      >
        <span>Précédent</span>
      </Button>

      <div className={'fr-paginator--page-container'}>
        {buildPages().map((pageElement, index) => (pageElement === '...')
          ? <span key={'ellipsis' + index} className={'px-2'}>...</span>
          : <div key={pageElement + index}
                 className={`fr-paginator--page ${displayedPage === pageElement ? '__selected' : ''}`}
                 onClick={() => onPageChange?.(pageElement - 1)}>
            <span>{pageElement}</span>
          </div>,
        )}
      </div>

      <Button
        iconId="fr-icon-arrow-right-s-line"
        iconPosition={'right'}
        onClick={() => onPageChange?.(page + 1)}
        priority="tertiary no outline"
        disabled={page === totalPages - 1 || totalPages === 0}
      >
        <span>Suivant</span>
      </Button>
    </div>
  );
};

interface FcPaginationProps {
  page: number;
  totalPages: number;
  onPageChange?: (page: number) => void;
  /**
   * Nombre de pages à afficher de part et d'autre de la page actuelle.
   * Le surplus est remplacé par "...".
   * @default 2
   */
  ellipsis?: number;
}